<template>
    <div class="learn-history">
        <div class="title">{{$t('business_school.learning_history')}}
            <div class="back" @click="$router.go(-1)">
                <van-icon name="arrow-left" />
            </div>
        </div>
        <div class="tabs">
            <van-tabs v-model:active="typeId" type="card" :ellipsis="false" @change="onClickTab">
                <van-tab v-for="item in courseBtnList" :key="item.title" :name="item.value" :title="item.title"></van-tab>
            </van-tabs>
        </div>
        <div class="historyList">

            <div class="courseList" v-for="item in courseList" :key="item.name">
                <template v-if="item.course.length">
                    <div class="name">{{ item.name }}</div>
                    <div class="course" @click="toPage('/learn-detail',{id: e.id})" v-for="(e,i) in item.course" :key="item.name+i">
                        <div class="courseLeft">
                            <van-image :src="$utils.setSourcePath(e.preview)">
                                <span>{{e.date}}</span>
                            </van-image>
                            
                        </div>
                        <div class="courseRight">
                            <div class="title ellipsis">{{ e.name }}</div>
                            <div class="tag">{{ e.typeName }}</div>
                            <div class="timeBtn">
                                <span>{{ e.length }}{{$t('business_school.min')}}</span>
                                <sd-button mini2>{{$t('text.learn')}}</sd-button>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "cases",
    components: {  },
    data() {
        return {
            typeId: '',
            courseBtnList: [],
            courseList: [
                {
                    name:this.$t('text.today'),
                    course:[]
                },
                {
                    name:this.$t('text.before'),
                    course:[]

                }
            ],
        }
    },

    computed: {
        
    },

    watch: {},

    mounted() {
        this.getData();
        this.getCourseTypeList();
    },

    methods: {
        
        getCourseTypeList() {
            this.$apis.school.getCourseTypeList().then(res => {
                this.courseBtnList = res.data.list.map(item => {
                    return {
                        title: item.typeName,
                        value: item.id
                    }
                })
                this.courseBtnList.unshift({ title: this.$t('text.all'), value: '' });
            }).catch(err => {
                console.error(err)
            })
        },
        getData() {
            this.$apis.school.getCourseHistoricalRecord({typeId: this.typeId}).then(res=>{
                const records = res.data.records
                this.courseList[0].course = []
                this.courseList[1].course = []
                records.forEach(item => {
                    item.date = item.updateTime.split(' ')[0]
                    if (item.date === this.currentDate()) {
                        this.courseList[0].course.push({
                            name: item.title,
                            url: item.preview,
                            date: item.updateTime.split(' ')[0],
                            ...item
                        })
                    } else {
                        this.courseList[1].course.push({
                            name: item.title,
                            url: item.preview,
                            date: item.updateTime.split(' ')[0],
                            ...item
                        })
                    }
                })
                console.log(this.courseList);
                
            })
        },
        
        currentDate() {
            const date = new Date();
            return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate()}`;
        },
        onLoad() {
        // 异步更新数据
        // setTimeout 仅做示例，真实场景中一般为 ajax 请求
        setTimeout(() => {
            for (let i = 0; i < 10; i++) {
                this.list.push({
                    rank: this.list.length+1,
                    name: 'demo'+(this.list.length+1),
                    dec: 'demo'+(this.list.length+1),
                    number: Math.floor(Math.random() * 100) + 1
                });
            }

            // 加载状态结束
            this.loading = false;

            // 数据全部加载完成
            if (this.list.length >= 40) {
                this.finished = true;
            }
        }, 1000);
        },
        onClickTab(){
            console.log(this.typeId);
            this.getData()
        },
        toPage(path, query) {
            this.$router.push({
                path, query
            })
        },
    },

    beforeDestroy() {
    }
}
</script>

<style lang="scss">
.learn-history {
    background: #F4F5F8;
    height: 100%;
    overflow: auto;
    font-size: 14px;
    font-weight: bold;
    .title{
        background-color: #fff;
        font-size: 16px;
        height: 50px;
        line-height: 50px;
        .back{
            position: absolute;
            top: 0;
            left: 0;
            margin-left: 10px;
        }
    }
    .van-tabs__nav--card{
        border: none;
    }
    .tabs{
        width: 100%;
        height: 60px;
        overflow: auto;
        display: flex;
        align-items: center;
        &::-webkit-scrollbar {
          display: none;
        }
        .van-tabs__wrap{
            overflow: inherit;
        }
        .van-tabs__nav{
            background: #F4F5F8;
            height: 30px;
            .van-tab{
                font-size: 14px;
                background: #fff;
                color: #666;
                border-radius: 10px;
                border: none;
                margin-right: 10px;
            }
            .van-tab--active{
                color: #fff;
                background: #ee0a24;
            }
        }
    }
    .historyList{
        width: 100%;
        overflow: auto;
        height: calc(100% - 110px);
        &::-webkit-scrollbar {
          display: none;
        }
        .courseList{
            margin: 10px;
            width: calc(100% - 20px);
            .name{
                font-size: 16px;
                text-align: left;
            }
            .course{
                box-sizing: border-box;
                width: 100%;
                display: flex;
                padding: 10px;
                border-radius: 5px;
                background: #fff;
                margin-top: 20px;
                .courseLeft{
                    .van-image{
                        width: 150px;
                        height: 100px;
                        span{
                            background: rgba(0,0,0,.4);
                            padding: 2px;
                            color: #fff;
                            border-radius: 4px;
                            position: absolute;
                            bottom: 0;
                            min-width: 40px;
                            left: 4px;
                            bottom: 4px;
                            font-weight: normal;
                        }
                    }
                }
                .courseRight{
                    width: calc(100% - 150px);
                    .tag{
                        font-weight: normal;
                        display: inline-block;
                        padding: 4px;
                        border-radius: 4px;
                        color: #636872;
                        background: #e6e7ea;
                        float: left;
                        margin-left: 10px;
                    }
                    .title{
                        text-align: left;
                        text-indent: 5px;
                    }
                    .timeBtn{
                        width: calc(100% - 20px);
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 10px;
                        .main-block{
                            width: 80px;
                            height: 30px;
                        }
                    }
                }
            }

        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/school/learningHistory.vue